import ExtendedBaseConnector from './ExtendedBaseConnector';

interface PGWalletProvider {
  connect: () => Promise<void>;
  getAccounts: () => Promise<string[]>;
  getPublicKey: () => Promise<string>;
  signPsbt: (psbt: string) => Promise<string>;
}

declare global {
  interface Window {
    pgwallet: PGWalletProvider;
  }
}

export class PGWalletConnector extends ExtendedBaseConnector {
  constructor() {
    super();
  }

  readonly metadata: ExtendedBaseConnector['metadata'] = {
    id: 'pgwallet',
    name: 'PrettyGoodKeyboard',
    icon: '/wallets/pgwallet.svg',
    downloadUrl: 'https://www.pgwallet.com/download/',
  };

  isReady(): boolean {
    return typeof window !== 'undefined' && typeof window.pgwallet !== 'undefined';
  }

  private loadAccounts = async () => {
    await window.pgwallet.connect();
    const addresses = await window.pgwallet.getAccounts();

    return addresses;
  };

  sendInscription(): Promise<{ txid: string }> {
    throw new Error('Unsupported');
  }

  async requestAccounts(): Promise<string[]> {
    if (!this.isReady()) {
      throw new Error(`${this.metadata.name} is not installed!`);
    }

    return this.loadAccounts();
  }

  getAccounts(): Promise<string[]> {
    if (!this.isReady()) {
      throw new Error(`${this.metadata.name} is not installed!`);
    }
    return window.pgwallet.getAccounts();
  }

  async getPublicKey(): Promise<string> {
    if (!this.isReady()) {
      throw new Error(`${this.metadata.name} is not installed!`);
    }

    return window.pgwallet.getPublicKey();
  }

  signMessage(_signStr: string): Promise<string> {
    throw new Error('Unsupported');
  }

  on(event: string, handler: (data?: unknown) => void) {
    return this.eventEmitter.on(event, handler);
  }

  removeListener(event: string, handler: (data?: unknown) => void) {
    return this.eventEmitter.removeListener(event, handler);
  }

  getProvider() {
    if (this.isReady()) {
      return window.pgwallet;
    }
  }

  getNetwork(): Promise<'livenet' | 'testnet'> {
    if (!this.isReady()) {
      throw new Error(`${this.metadata.name} is not installed!`);
    }

    return Promise.resolve('livenet');
  }

  switchNetwork(): Promise<void> {
    throw new Error('Unsupported');
  }

  sendBitcoin(_toAddress: string, _satoshis: number): Promise<string> {
    throw new Error('Unsupported');
  }
}
